
import {defineComponent, PropType} from "vue";
import {CustomerProductCategoryTreeNode} from "@/models/api/pharma-cpc-product-category-mgmt/CustomerProductCategoryTreeNode";
import BaseOffcanvasButtonOpen from "@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonOpen.vue";

export default defineComponent({
  name: "CustomerCategoryNode",
  components: {BaseOffcanvasButtonOpen},
  emits: ["editCategory", "deleteCategory", "toggleOpen"],
  props: {
    treeNode: {
      type: Object as PropType<CustomerProductCategoryTreeNode>,
      required: true,
    },
    level: {
      type: Number,
      required: true
    },
    open: {
      type: Object as PropType<Set<string>>,
      required: true,
    },
  },
  computed: {
    hasChildren(): boolean {
      return this.treeNode.children?.length > 0;
    },
    isFirstLevel(): boolean {
      return this.level === 0;
    },
    canEdit(): boolean {
      // Only show edit/delete for non-first-level nodes that have customerCategory data
      return !this.isFirstLevel && this.treeNode.customerCategory !== null;
    },
    canDelete(): boolean {
      // Can only delete if it has no children and is editable
      return this.canEdit && !this.hasChildren;
    },
    paddingStyle(): string {
      return 'padding-left: ' + (this.level * 15) + 'px';
    },
    isOpen(): boolean {
      return this.open.has(this.treeNode.code);
    },
  },
  methods: {
    toggleOpen(code: string) {
      this.$emit('toggleOpen', code);
    },
  }
});
